export enum systemImportNames {
  'Scopus' = 'Scopus', // Scopus
  'WoS' = 'WoS', // WoS
  'Elib' = 'Elib', // Elib
  'lk' = 'lk', // Elib
  'ctt' = 'ctt',
  'merge' = 'merge',
  'total' = 'total',
  'sjr' = 'sjr',
  'sjrDump' = 'sjr-dump',
  'vac' = 'vac',
  'portfolioUsers' = 'portfolio-users',
  'recalcuateDuplicates' = 'recalcuate-duplicates'
}

export const systemImportNamesTranslation: { [k: string]: string } = {
  [systemImportNames.Elib]: 'Elib',
  [systemImportNames.WoS]: 'WoS',
  [systemImportNames.Scopus]: 'Scopus',
  [systemImportNames.lk]: 'ЛК ЛЭТИ',
  [systemImportNames.ctt]: 'Роспатент',
  [systemImportNames.merge]: 'Объединение авторов статей',
  [systemImportNames.total]: 'Полный импорт статей',
  [systemImportNames.sjr]: 'Квартили SJR (XLSX)',
  [systemImportNames.sjrDump]: 'Квартили SJR (дамп)',
  [systemImportNames.vac]: 'Квартили ВАК',
  [systemImportNames.portfolioUsers]: 'Пользователи из Портфолио',
  [systemImportNames.recalcuateDuplicates]: 'Обновить дубликаты публикаций'
}

export const systemImportNamesReverse: { [k: string]: string } = {}

for (const [k, v] of Object.entries(systemImportNamesTranslation)) {
  systemImportNamesReverse[v] = k
}

export enum systemIndexingNames {
  'WoS' = 'WoS', // WoS
  'RSCIWoS' = 'RSCIWoS', // RSCIWoS
  'Scopus' = 'Scopus', // Scopus
  'Elib' = 'Elib', // Elib
  'VAC' = 'VAC' // VAC
}

export const systemIndexingNamesTranslation: { [k: string]: string } = {
  [systemIndexingNames.WoS]: 'WoS',
  [systemIndexingNames.RSCIWoS]: 'RSCI WoS',
  [systemIndexingNames.Scopus]: 'Scopus',
  [systemIndexingNames.Elib]: 'РИНЦ',
  [systemIndexingNames.VAC]: 'ВАК'
}

export const systemIndexingNamesMap: { [k: string]: string } = {
  [systemIndexingNames.WoS]: 'indexedByWoS',
  [systemIndexingNames.RSCIWoS]: 'indexedByRSCIWoS',
  [systemIndexingNames.Scopus]: 'indexedByScopus',
  [systemIndexingNames.Elib]: 'indexedByElib',
  [systemIndexingNames.VAC]: 'indexedByVAC'
}
